import Service				from "./../../Libs/Service";

let Template = new Service({

	Name: "Template",

	Events: {

	},

	Actions: {

	},

	init() {

	}

});

window.Template = Template;

export { Template }

